var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { IsDateString, IsNumber, IsOptional, IsString } from 'class-validator';
export class CreateVehicleAccidentPersonDto {
}
__decorate([
    IsString(),
    __metadata("design:type", String)
], CreateVehicleAccidentPersonDto.prototype, "vehicleNumber", void 0);
__decorate([
    IsString(),
    __metadata("design:type", String)
], CreateVehicleAccidentPersonDto.prototype, "driverName", void 0);
__decorate([
    IsDateString(),
    __metadata("design:type", String)
], CreateVehicleAccidentPersonDto.prototype, "birthDate", void 0);
__decorate([
    IsString(),
    __metadata("design:type", String)
], CreateVehicleAccidentPersonDto.prototype, "licenseNumber", void 0);
__decorate([
    IsString(),
    __metadata("design:type", String)
], CreateVehicleAccidentPersonDto.prototype, "phoneNumber", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], CreateVehicleAccidentPersonDto.prototype, "insuranceCompany", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], CreateVehicleAccidentPersonDto.prototype, "serviceCenter", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], CreateVehicleAccidentPersonDto.prototype, "note", void 0);
__decorate([
    IsNumber(),
    IsOptional(),
    __metadata("design:type", Number)
], CreateVehicleAccidentPersonDto.prototype, "vehicleDamageFee", void 0);
__decorate([
    IsNumber(),
    IsOptional(),
    __metadata("design:type", Number)
], CreateVehicleAccidentPersonDto.prototype, "personDamageFee", void 0);
__decorate([
    IsNumber(),
    IsOptional(),
    __metadata("design:type", Number)
], CreateVehicleAccidentPersonDto.prototype, "materialDamageFee", void 0);
__decorate([
    IsNumber(),
    IsOptional(),
    __metadata("design:type", Number)
], CreateVehicleAccidentPersonDto.prototype, "accidentPercentage", void 0);
__decorate([
    IsNumber(),
    IsOptional(),
    __metadata("design:type", Number)
], CreateVehicleAccidentPersonDto.prototype, "charge", void 0);
